"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMsgSend = exports.msgSendTypes = void 0;
exports.msgSendTypes = {
    MsgValue: [
        { name: 'from_address', type: 'string' },
        { name: 'to_address', type: 'string' },
        { name: 'amount', type: 'TypeAmount[]' },
    ],
    TypeAmount: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
    ],
};
function createMsgSend(amount, denom, fromAddress, toAddress) {
    return {
        type: 'cosmos-sdk/MsgSend',
        value: {
            amount: [
                {
                    amount,
                    denom,
                },
            ],
            from_address: fromAddress,
            to_address: toAddress,
        },
    };
}
exports.createMsgSend = createMsgSend;
//# sourceMappingURL=msgsend.js.map